import { FC } from "react";
import dynamic from "next/dynamic";
import { TeamSelector } from "./TeamSelector";

const DynamicSearchBox = dynamic(() => import("./HeaderSearchBox"), {
    ssr: false,
    loading: () => <div className="h-9" />,
});

const DynamicHeaderProfile = dynamic(() => import("./HeaderProfile"), {
    ssr: false,
    loading: () => <div className="h-9" />,
});

const Header: FC = () => {
    return (
        <header className="flex items-center justify-between py-4 pr-5">
            <div>
                <TeamSelector />
            </div>
            <div className="flex items-center justify-end gap-20">
                <DynamicSearchBox />
                <DynamicHeaderProfile />
            </div>
        </header>
    );
};

export default Header;
